module.exports = __webpack_public_path__ + "img/crizal-alize-prevencia.c0e9a5b4.svg";